var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useRef } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { createTicket } from '../../services';
import useClientCode from '../../../CreateReservation/ReservationForm/hooks/useClientCode';
import { getData, ROUTES } from 'src/Utils';
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from 'src/Utils/toastMessages';
import { showSuccessToast, showErrorToast } from 'src/Utils/toastHelper';
import { TYPE_CONTACT } from 'src/Utils/constants';
export var useTicketForm = function (_a) {
    var initialFormData = _a.initialFormData, _b = _a.isInternal, isInternal = _b === void 0 ? false : _b, customValidation = _a.customValidation, onSuccess = _a.onSuccess, _c = _a.requireCommunicationChannel, requireCommunicationChannel = _c === void 0 ? true : _c;
    var history = useHistory();
    var isContact = Cookies.get('User') === TYPE_CONTACT;
    var _d = useState(initialFormData), formData = _d[0], setFormData = _d[1];
    var _e = useState({}), errors = _e[0], setErrors = _e[1];
    var _f = useState(''), clientCode = _f[0], setClientCode = _f[1];
    var _g = useState(false), isNavigatingAfterSubmit = _g[0], setIsNavigatingAfterSubmit = _g[1];
    var redirectTimeoutRef = useRef(null);
    // Fetch building data with code
    var _h = useQuery('buildings', function () {
        return getData('/buildings').then(function (res) { return res.buildings || []; });
    }).data, buildings = _h === void 0 ? [] : _h;
    // Fetch tower data with code
    var _j = useQuery(['towers', formData.building_id], function () {
        return getData("/buildings/" + formData.building_id + "/towers").then(function (res) { return res.towers || []; });
    }, { enabled: !!formData.building_id }).data, towers = _j === void 0 ? [] : _j;
    // Fetch apartment data
    var _k = useQuery(['apartments', formData.building_id, formData.tower_id], function () {
        var url = formData.tower_id
            ? "/buildings/" + formData.building_id + "/apartments/dropdown?tower=" + formData.tower_id
            : "/buildings/" + formData.building_id + "/apartments/dropdown";
        return getData(url).then(function (res) { return res.apartments || []; });
    }, { enabled: !!formData.building_id }).data, apartments = _k === void 0 ? [] : _k;
    // Transform form data to match useClientCode interface
    var selectedBuilding = formData.building_id
        ? {
            code: formData.building_code,
            id: formData.building_id,
            label: formData.building_code,
            value: formData.building_id,
        }
        : undefined;
    var selectedTower = formData.tower_id
        ? {
            code: formData.tower_code,
            id: formData.tower_id,
            label: formData.tower_code,
            value: formData.tower_id,
        }
        : undefined;
    var selectedApartment = formData.apartment_id
        ? {
            label: formData.apartment_number,
            value: formData.apartment_id,
        }
        : undefined;
    var placeData = {
        value: formData.relation === 'tenant'
            ? 'I'
            : formData.relation === 'proprietary'
                ? 'P'
                : formData.relation === 'both'
                    ? 'A'
                    : '',
        label: formData.relation === 'tenant'
            ? 'Inquilino'
            : formData.relation === 'proprietary'
                ? 'Propietario'
                : formData.relation === 'both'
                    ? 'Ambos'
                    : '',
    };
    // Use the client code hook
    useClientCode({
        selectedBuilding: selectedBuilding,
        selectedTower: selectedTower,
        selectedApartment: selectedApartment,
        setClientCode: setClientCode,
        placeData: placeData,
    });
    // Form submission mutation
    var _l = useMutation(createTicket, {
        onSuccess: function () {
            var message;
            if (isInternal) {
                message = SUCCESS_MESSAGES.tickets.internalCreated;
            }
            else if (isContact) {
                message = SUCCESS_MESSAGES.tickets.createdReclamo;
            }
            else {
                message = SUCCESS_MESSAGES.tickets.created;
            }
            showSuccessToast(message);
            resetForm();
            setErrors({});
            if (onSuccess) {
                onSuccess();
            }
            else {
                setIsNavigatingAfterSubmit(true);
                // Navigate to the correct index page after successful creation
                redirectTimeoutRef.current = setTimeout(function () {
                    history.push(isContact ? ROUTES.client_tickets : ROUTES.tickets);
                }, 2000);
            }
        },
        onError: function (error) {
            setIsNavigatingAfterSubmit(false);
            var errorMessage;
            if (isInternal) {
                errorMessage = ERROR_MESSAGES.tickets.createInternal;
            }
            else if (isContact) {
                errorMessage = ERROR_MESSAGES.tickets.createReclamo;
            }
            else {
                errorMessage = ERROR_MESSAGES.tickets.create;
            }
            showErrorToast(error, errorMessage);
            setErrors({ general: errorMessage });
        },
    }), mutateCreateTicket = _l[0], isSubmitting = _l[1].isLoading;
    var handleInputChange = function (field, value) {
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
        if (errors[field]) {
            setErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[field] = '', _a)));
            });
        }
    };
    var validateForm = function () {
        var newErrors = {};
        // Required fields validation
        if (!formData.building_id && !isInternal)
            newErrors.building_id = 'Edificio es requerido';
        if (isContact && !formData.apartment_id && !isInternal) {
            newErrors.apartment_id = 'Apartamento es requerido';
        }
        if (!formData.title.trim())
            newErrors.title = 'Título es requerido';
        if (!formData.description.trim())
            newErrors.description = 'Descripción es requerida';
        if (!formData.provider_service && !isInternal)
            newErrors.provider_service = 'Tipo de servicio es requerido';
        if (requireCommunicationChannel && !formData.communication_channel) {
            newErrors.communication_channel = 'Canal de comunicación es requerido';
        }
        if (customValidation && !isContact) {
            var customErrors = customValidation(formData);
            Object.assign(newErrors, customErrors);
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var submitData, externalFormData, apartmentContacts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting || isNavigatingAfterSubmit)
                        return [2 /*return*/];
                    if (!validateForm())
                        return [2 /*return*/];
                    submitData = {
                        building_id: formData.building_id,
                        title: formData.title,
                        description: formData.description,
                        provider_service: formData.provider_service,
                        communication_channel: formData.communication_channel,
                        internal: isInternal,
                        external_client: !isInternal && 'client_selection' in formData
                            ? formData.client_selection === 'other'
                            : false,
                        apartment_id: formData.apartment_id || undefined,
                        assignee_id: formData.assignee_id || undefined,
                        numeric_client_code: formData.apartment_id ? clientCode : undefined,
                    };
                    // Add external client specific fields
                    if (!isContact && !isInternal && 'client_selection' in formData) {
                        externalFormData = formData;
                        if (externalFormData.client_selection === 'existing') {
                            submitData.apartment_contact_id =
                                externalFormData.apartment_contact_id || undefined;
                        }
                        if (externalFormData.client_selection === 'new') {
                            submitData.new_contact = {
                                first_name: externalFormData.external_client_first_name,
                                last_name: externalFormData.external_client_last_name,
                                email: externalFormData.external_client_email,
                                mobile: externalFormData.external_client_phone,
                            };
                        }
                        if (externalFormData.client_selection === 'other') {
                            submitData.external_client_first_name =
                                externalFormData.external_client_first_name || undefined;
                            submitData.external_client_last_name =
                                externalFormData.external_client_last_name || undefined;
                            submitData.external_client_phone =
                                externalFormData.external_client_phone || undefined;
                        }
                    }
                    if (!isContact) return [3 /*break*/, 2];
                    return [4 /*yield*/, getData('/apartment_contacts', {
                            params: { apartment_id: formData.apartment_id },
                        })];
                case 1:
                    apartmentContacts = _a.sent();
                    submitData.apartment_contact_id =
                        apartmentContacts.apartment_contacts[0].id;
                    _a.label = 2;
                case 2:
                    mutateCreateTicket(submitData);
                    return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setFormData(initialFormData);
    };
    // Reset dependent fields when parent changes
    useEffect(function () {
        setFormData(function (prev) { return (__assign(__assign({}, prev), { tower_id: null, tower_code: '', apartment_id: null, apartment_number: '' })); });
    }, [formData.building_id]);
    useEffect(function () {
        setFormData(function (prev) { return (__assign(__assign({}, prev), { apartment_id: null, apartment_number: '' })); });
    }, [formData.tower_id]);
    useEffect(function () { return function () {
        if (redirectTimeoutRef.current) {
            clearTimeout(redirectTimeoutRef.current);
        }
    }; }, []);
    var formState = {
        formData: formData,
        errors: errors,
        clientCode: clientCode,
        isSubmitting: isSubmitting || isNavigatingAfterSubmit,
    };
    var formActions = {
        setFormData: setFormData,
        setErrors: setErrors,
        setClientCode: setClientCode,
        handleInputChange: handleInputChange,
        validateForm: validateForm,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
    };
    return {
        formState: formState,
        formActions: formActions,
        buildings: buildings,
        towers: towers,
        apartments: apartments,
    };
};
